<script>
  import { createEventDispatcher } from "svelte";
  import { Circle } from "svelte-loading-spinners";
  import Select from "svelte-select";
  import config from "../../../stores/config";
  import Modal from "./../../../shared/Modal.svelte";
  import StyleRow from "./StyleRow.svelte";
  import * as ls from "local-storage";
  import axios from "axios";
  import StyleHeader from "./StyleHeader.svelte";
  const dispatch = createEventDispatcher();

  let authData = { headers: { authorization: ls.get("jwt") } };

  export let customerID;
  export let orderID;
  export let orderStyles;
  export let orderNumber;
  export let dateOrdered;

  // For selectBox
  let sStyleName = null;
  let sCMT = null;

  const emptyNewStyle = {
    fStyleID: null,
    qtyOrdered: null,
    qtyMade: 0,
    rejects: 0,
    reworks: 0,
    cutSheetN: null,
    expectedDeliveryDate: null,
  };

  let newStyle = { ...emptyNewStyle };

  let showAddNewStyleForm = false;
  let addNewStyleLoading = false;

  const handleAddNewStyle = async (e) => {
    if (!sStyleName.value) alert("⚠ Style name missing!");
    if (!sCMT.value) alert("⚠ CMT missing!");
    else if (newStyle.qtyOrdered == undefined)
      alert("⚠ Quantity Ordered missing!");
    else if (!newStyle.expectedDeliveryDate)
      alert("⚠ Expected Delivery Date name missing!");
    else if (newStyle.qtyMade == undefined) alert("⚠ Quantity made missing!");
    else {
      addNewStyleLoading = true;

      let { materialReq } = sStyleName;

      materialReq = materialReq.map((m) => ({
        ...m,
        qtyReq: m.qtyReq * newStyle.qtyOrdered,
      }));

      let data = {
        ...newStyle,
        uPrice: $config.fstyles.find((s) => s.value == sStyleName.value).price,
        fStyleID: sStyleName.value,
        cmtID: sCMT.value,
        materialReq,
        // cutSheetN: Math.random().toString().split(".")[1].slice(0, 8),
        cutSheetN: `${dateOrdered
          .slice(0, 10)
          .replaceAll(/\W/g, "")}-${orderNumber}`,
      };

      axios
        .put(
          `${$config.backendURL}/orders/${orderID}/add-style`,
          data,
          authData
        )
        .then((res) => {
          showAddNewStyleForm = false;
          addNewStyleLoading = false;
          newStyle = { ...emptyNewStyle };
          dispatch("reloadData");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
</script>

<Modal
  show={showAddNewStyleForm}
  on:modalClose={() => {
    showAddNewStyleForm = false;
  }}
>
  <div class="grid gap-y-2">
    <div class="flex items-center text-gray-600 text-sm">
      <span class="flex items-center mr-2">
        <i class="fas fa-info-circle text-green-400" />
      </span>
      If the style name is not in the list 👇, add it to the styles stock first.
    </div>

    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Select Style Name :</div>
      <div class="col-span-2">
        <Select
          items={$config.fstyles}
          on:select={(e) => (sStyleName = e.detail)}
        />
      </div>
    </div>

    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Choose a CMT :</div>
      <div class="col-span-2">
        <Select items={$config.cmts} on:select={(e) => (sCMT = e.detail)} />
      </div>
    </div>

    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Quantity Ordered :</div>
      <input
        class="col-span-2"
        bind:value={newStyle.qtyOrdered}
        type="number"
        step="any"
        placeholder="Quantity Ordered"
      />
    </div>

    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Expected Delivery Date :</div>
      <input
        class="col-span-2"
        bind:value={newStyle.expectedDeliveryDate}
        type="date"
        placeholder="Expected Delivery Date"
      />
    </div>

    {#if addNewStyleLoading}
      <div class="flex items-center justify-center btn btn-green-outline">
        <Circle size="25" color="rgb(16, 185, 129)" unit="px" />
        <span class="ml-4">Please wait...</span>
      </div>
    {:else}
      <!-- else content here -->
      <div class="flex">
        <button
          style="width: 100%;"
          class="btn btn-green"
          on:click={handleAddNewStyle}
        >
          <i class="fas fa-check-circle mr-3" />
          Save
        </button>
        <button
          style="width: 100%;"
          class="ml-4 btn btn-gray"
          on:click={(e) => (showAddNewStyleForm = false)}
        >
          <i class="fas fa-times-circle mr-3" />
          Close
        </button>
      </div>
    {/if}
  </div>
</Modal>

<div class="grid grid-cols-1 gap-4">
  <button
    class="btn btn-green"
    on:click={(e) => (showAddNewStyleForm = true)}
    style="width: 100%;"
  >
    <i class="fas fa-plus-circle mr-3" />
    Add a new Style
  </button>
</div>

{#if orderStyles == null}
  <div class="loading-screen h-screen flex items-center justify-center">
    <Circle size="50" color="rgb(16, 185, 129)" unit="px" />
  </div>
{:else}
  <div
    class="mt-6 bg-white rounded-md shadow-sm w-full overflow-auto text-gray-500 text-sm"
  >
    <StyleHeader />
    {#each orderStyles as orderStyle (orderStyle._id)}
      <div class="">
        <StyleRow
          {...orderStyle}
          {orderID}
          {customerID}
          {orderNumber}
          on:delete={() => dispatch("reloadData")}
          on:update={() => dispatch("reloadData")}
        />
      </div>
    {:else}
      <div class="col-span-full">
        <div class="h-52 w-full flex items-center justify-center uppercase">
          No styles for the order yet...
        </div>
      </div>
    {/each}
  </div>
{/if}
